import { useQuery } from '@tanstack/react-query'

import {
  getPublisherConfigurationKey,
  getPublisherConfigurationService
} from '~/modules/retailMedia/services/configuration/publisher'
import { getPublisherService } from '~/modules/retailMedia/services/publisher'

type PublisherConfigurationData = {
  publisherId: string
  publisherName: string
  config: PublisherConfiguration | null
}

export const usePublishersConfigurations = (
  selectedPublishers: PublisherId[]
) => {
  const {
    data: selectedPublishersConfigurations,
    isLoading: isLoadingConfigurations
  } = useQuery<PublisherConfigurationData[]>({
    queryKey: [getPublisherConfigurationKey, selectedPublishers],
    queryFn: async () => {
      if (!selectedPublishers || selectedPublishers.length === 0) {
        return []
      }

      const configs = await Promise.all(
        selectedPublishers.map(async pubId => {
          try {
            const [configResponse, publisherResponse] = await Promise.all([
              getPublisherConfigurationService(pubId),
              getPublisherService({ url: { id: pubId } })
            ])
            return {
              publisherId: pubId,
              publisherName: publisherResponse.data.name,
              config: configResponse.data
            }
          } catch (error) {
            console.error(
              `Error fetching config for publisher ${pubId}:`,
              error
            )
            return { publisherId: pubId, publisherName: '', config: null }
          }
        })
      )

      return configs
    },
    enabled: selectedPublishers && selectedPublishers.length > 0
  })

  return {
    selectedPublishersConfigurations,
    isLoadingConfigurations
  }
}
